export const AUTO_CLOSE = 3000;
